"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxElement = function CheckboxElement(_ref) {
  var item = _ref.item;
  console.log("ESTILOS CheckboxElement field: ", item);
  var defaultStyles = {
    marginTop: 15
  };
  var style = !item.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(item.customStyles);
  console.log("ESTILOS CheckboxElement style: ", style);
  return /*#__PURE__*/React.createElement(_core.FormGroup, {
    row: true,
    style: style
  }, item.attributes.map(function (atr, i) {
    return /*#__PURE__*/React.createElement(_core.FormControlLabel, {
      disabled: true,
      key: i,
      control: /*#__PURE__*/React.createElement(_core.Checkbox, {
        color: "primary",
        checked: atr.value
      }),
      label: atr.labelInside
    });
  }));
};

var _default = CheckboxElement;
exports.default = _default;